import { render, staticRenderFns } from "./TaxServices.vue?vue&type=template&id=76d85d50&"
import script from "./TaxServices.vue?vue&type=script&lang=ts&"
export * from "./TaxServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports